export default __webpack_public_path__ + "facebook.9a27b753dd53f4f183bd8e4834ea958a.svg";